import React from "react";
import LinkItem from "../Helpers/LinkItem";

const Template2 = ({
  profileImage,
  backgroundImage,
  bio,
  profileName,
  profilePosition,
  profileColor,
  links,
  email,
}) => {
  return (
    <div className="bg-yellow-50 min-h-screen flex items-center justify-center text-gray-900">
      <div
        className="relative border shadow-lg rounded-2xl bg-cover bg-center w-[375px] h-[812px]"
        style={{
          backgroundImage: backgroundImage ? `url(${backgroundImage})` : "none",
        }}
      >
        <div
          className={`h-full p-6 ${
            profilePosition ? `text-${profilePosition}` : "text-center"
          }`}
        >
          {/* Conditional rendering for profile image */}
          {profileImage && (
            <img
              src={profileImage}
              alt="Profile"
              className="w-28 h-28 rounded-full mx-auto mb-4 border-2 border-gray-200 shadow-lg"
            />
          )}

          {/* Conditional rendering for profile name */}
          {profileName && (
            <h1
              className="text-3xl font-extrabold tracking-wide"
              style={{ color: profileColor || "#222" }} // Default to dark text if no profileColor
            >
              {profileName}
            </h1>
          )}

          {/* Conditional rendering for email */}
          {email && <p className="text-md text-gray-700 mt-2">{email}</p>}

          {/* Conditional rendering for bio */}
          {bio && <p className="italic text-sm mt-3 text-gray-600">{bio}</p>}

          {/* Conditional rendering for links */}
          {links && links.length > 0 && (
            <div className="mt-8 space-y-3">
              {links.map((link) => (
                <LinkItem key={link.id} link={link} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Template2;
